// Vuex connections module actions

import { API } from '@/config';
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  SET_CONNECTIONS_PER_PAGE,
  SET_SORTING_DIRECTION,
  FILL_HISTORY_LIST,
} from './mutations-types';

export default {
  async getHistoryList({ commit }, data) {
    try {
      const params = { ...data };
      const {
        records,
        total,
      } = (await API.get('/connections/callHistory/getList', { params })).data.data;
      commit(FILL_HISTORY_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  async getList({ state, commit }) {
    try {
      const params = {
        filtering_criteria: hParseToFilterCriteriaObjectRequiredByApi(state.filteringCriteria),
        page: state.list.page,
        page_size: state.connectionsPerPage,
        sorting_direction: state.sortingDirection,
      };
      const { records, total } = (await API.get('/connections/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  filterList({ state, commit, dispatch }, params) {
    commit(SET_PAGE, { page: 1 });
    try {
      const filterCriteria = {...state.filteringCriteria};
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== '') {
          filterCriteria[key] = {
            value: params[key],
            name: key,
            label: key,
          };
        }
      });
      if (Object.keys(filterCriteria).length !== 0) {
        commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
        dispatch('getList');
      } else {
        commit(FILL_LIST, { records: [], total: 0 });
      }
    } catch (err) {
      console.log(err);
    }
  },

  clearFilteringCriteria({ commit }) {
    commit(SET_PAGE, { page: 1 });
    commit(SET_FILTERING_CRITERIA, {});
  },
  changePage({ commit, dispatch }, page) {
    commit(SET_PAGE, { page });
    dispatch('getList');
  },
  changeConnectionsPerPage({ commit, dispatch }, connectionsPerPage) {
    commit(SET_PAGE, { page: 1 });
    commit(SET_CONNECTIONS_PER_PAGE, connectionsPerPage);
    dispatch('getList');
  },
  changeSortingDirection({ commit, dispatch }, sortingDirection) {
    commit(SET_PAGE, { page: 1 });
    commit(SET_SORTING_DIRECTION, sortingDirection);
    dispatch('getList');
  },
};
